// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"55049ecb","732":"96bc914e","977":"6c9b6bb6"}[chunkId] + ".chunk.js";
};